import { useEffect, useState } from "react";
import { Col, Form, InputGroup, Row, Button, Table, Tabs, Tab } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { connect, useDispatch } from "react-redux";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import { selectErrorStyles, selectStyles } from "../../../../components/Select/styles";
import { emptyOption } from "../../../../constants";
import { setLoading } from "../../../../redux/Loading/actions";
import {
  getConvenio,
  getConvenios
} from "../../../../redux/Sections/Convenios/actions";
import { fixNumber, formatDeuda } from "../../../../utils/utils";
// import { fixNumber, formatDeuda, formatGastoFijo } from "../../../../utils/utils";
import { convenioService } from "../../../../_services/convenios.service";
import BuscarDeudas from "./BuscarDeudas";

import SimulacionPlanPago from "./SimulacionPlanPago";
import { useUser } from "../../../../hooks/useUser";
import SelectPlan from "../../../../components/SelectPlan";
import pako from "pako";

const defaultCuotas = 15;

// const NewConvenio = ({ handleNewConvenio, data, convCaracter, convEstados, convFormaPago, abogados }) => {
const NewConvenio = ({ handleNewConvenio, data, convCaracter, convEstados, convFormaPago, abogados, filters }) => {
  const dispatch = useDispatch();
  const user = useUser();
  const { register, handleSubmit, control, getValues, formState: { errors } } = useForm({});
  
  const [convEstadosState, setConvEstadosState] = useState({});
  const [gastosFijos, setGastosFijos] = useState({});
  const [periodos, setPeriodos] = useState({});
  const [monto, setMonto] = useState({});
  const [montoInteres, setMontoInteres] = useState({});
  const [montoOrigen, setMontoOrigen] = useState({});
  const [total, setTotal] = useState({});
  const [totalOrigen, setTotalOrigen] = useState({});
  const [totalInteres, setTotalInteres] = useState({});
  const [cuotas, setCuotas] = useState({});
  const [contado, setContado] = useState({});

  const [showSimulacion, setShowSimulacion] = useState("");
  const [simulacionpp, setSimulacionpp] = useState("");
  const [caracter, setCaracter] = useState("");
  const [estado, setEstado] = useState("");
  const [formaPago, setFormaPago] = useState("");

  const [deudas, setDeudas] = useState([]);
  const [totalDeuda, setTotalDeuda] = useState(0);
  const [periodosList, setPeridosList] = useState([]);

  const [tipoPlan, setTipoPlan] = useState("");
  const [anticipo, setAnticipo] = useState("");
  const [cuotasRafam, setCuotasRafam] = useState({});

  const [comercios, setComercios] = useState(false);
  const [key, setKey] = useState("inmuebles");

  useEffect(() => {
    const convEstadosFiltered = convEstados.filter((convEst) => convEst.nombre !== "Otros Gastos Convenios");
    setConvEstadosState(convEstadosFiltered);
    setGastosFijos(convEstados.filter((convEst) => convEst.nombre === "Otros Gastos Convenios")[0].jus);
  }, []);

  useEffect(() => {
    if (data?.planes) {
      let planes = JSON.parse(data.planes);

      let total = planes.reduce((prev, current) => {
        return +prev + +current.monto;
      }, 0);

      if (total) {
        setMonto(total);
      }

    }
  }, [data]);

  useEffect(() => {
    deudas.forEach(e => {
      if (e?.legal?.length) {
        if (!cuotas[e.recurso + "-" + e.imponible]) {
          setCuotas({ ...cuotas, [e.recurso + "-" + e.imponible]: defaultCuotas });
        }
      }
    });

  }, [deudas]);

  useEffect(() => {
    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +monto[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +monto[current]
          };
        }
      }, {});
      let resultOrigen = Object.keys(montoOrigen)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +montoOrigen[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +montoOrigen[current]
          };
        }
      }, {});
      let resultInteres = Object.keys(montoInteres)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +montoInteres[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +montoInteres[current]
          };
        }
      }, {});
      let totalDeuda = Object.values(monto).reduce((a, b) => a + b); 

      setTotalDeuda(fixNumber(totalDeuda));
      setTotal(result);
      setTotalOrigen(resultOrigen);
      setTotalInteres(resultInteres);
    }
  }, [monto]);

  const handleShowModal = (e) => {
    const { recurso, imponible } = e;

    if (!total[recurso + "-" + imponible]) return;
    if (!total[recurso + "-" + imponible]) return;
    if (tipoPlan[recurso + "-" + imponible] === "W2203" && !anticipo[recurso + "-" + imponible]) return;

    let jsdeuda = [];
    if (Object.values(cuotasRafam).length) {
      jsdeuda = Object.keys(cuotasRafam)?.reduce((prev, current) => {
        const [imp, rec] = current.split("-");

        if (rec === recurso && imp === imponible) {
          return [...prev, ...cuotasRafam[current]];
        }
        else {
          return prev;
        }
      }, []);
    }

    setSimulacionpp({
      ...e,
      total: total[recurso + "-" + imponible],
      cuotas: cuotas[recurso + "-" + imponible] || defaultCuotas,
      tipoPlan: tipoPlan[recurso + "-" + imponible],
      anticipo: anticipo[recurso + "-" + imponible],
      jsdeuda
    });

    setShowSimulacion(true);
  };

  const handleCloseModal = () => setShowSimulacion(false);

  const handleCuotas = (e) => {
    if (+e.target.value > 15) {
      e.target.value = 15;
      setCuotas({ ...cuotas, [e.target.name]: 15 });
    } else {
      setCuotas({ ...cuotas, [e.target.name]: e.target.value });
    }
  };

  const handleContado = (e) => setContado({ ...contado, [e.target.name]: e.target.checked });

  const handlePeriodos = ({ e, valueMonto, periodo, imponible, recurso, valueOrigen, valueInteres }) => {
  // const handlePeriodos = ({ e, valueMonto, periodo, imponible, recurso, deuda12, valueOrigen, valueInteres }) => {
    if (e.target.checked) {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] + valueMonto).toFixed(2) : valueMonto
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: montoOrigen[e.target.name] ? +Number(montoOrigen[e.target.name] + valueOrigen).toFixed(2) : valueOrigen
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: montoInteres[e.target.name] ? +Number(montoInteres[e.target.name] + valueInteres).toFixed(2) : valueInteres
      });

      setPeridosList((prev) => [...prev, { ...periodo, imponible, recurso }]);

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? [...cuotasRafam[e.target.name], periodo] : [periodo]
      });
    }
    else {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] - valueMonto).toFixed(2) : 0
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: montoOrigen[e.target.name] ? +Number(montoOrigen[e.target.name] - valueOrigen).toFixed(2) : 0
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: montoInteres[e.target.name] ? +Number(montoInteres[e.target.name] - valueInteres).toFixed(2) : 0
      });
      setPeridosList((prev) => prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA)));

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? cuotasRafam[e.target.name].filter((p) => !(p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA)) : []
      });
    }
  };

  const handleYear = ({ e, periodosData, valueMonto, deuda, imponible, recurso, valueOrigen, valueInteres }) => {
    if (e.target.checked) {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = true);
      setPeriodos({
        ...periodos,
        [e.target.name]: periodosData?.length
      });
      setMonto({
        ...monto,
        [e.target.name]: +valueMonto
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: +valueOrigen
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: +valueInteres
      });
      setPeridosList((prev) => {
        return [...prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)), ...deuda.periodos.map(e => { return { ...e, imponible, recurso }; })];
      });
      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: periodosData
      });
    }
    else {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = false);
      setMonto({ ...monto, [e.target.name]: 0 });
      setMontoOrigen({ ...montoOrigen, [e.target.name]: 0 });
      setMontoInteres({ ...montoInteres, [e.target.name]: 0 });
      setPeridosList((prev) => prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)));
      setCuotasRafam({ ...cuotasRafam, [e.target.name]: [] });
    }
  };

  const handleCheck = ({ e, deudas, imponible, recurso }) => {
    deudas.forEach((deuda, indx) => {
      let name = `${imponible}-${recurso}-${deuda.anio}-${indx}`;
      let length = deuda.periodos?.length;

      if (e.target.checked) {
        let checkboxs = document.getElementsByName([name]);
        checkboxs.forEach(p => p.checked = true);
        setPeriodos((prev) => {
          return {
            ...prev,
            [name]: length
          };
        });

        setMonto((prev) => {
          return {
            ...prev,
            [name]: +deuda.monto.toFixed(2)
          };
        });
        setMontoOrigen((prev) => {
          return {
            ...prev,
            [name]: +deuda.origen.toFixed(2)
          };
        });
        setMontoInteres((prev) => {
          return {
            ...prev,
            [name]: +deuda.interes.toFixed(2)
          };
        });

        setPeridosList((prev) => {
          return [...prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)), ...deuda.periodos.map(e => { return { ...e, imponible, recurso }; })];
        });

        setCuotasRafam((prev) => {
          return {
            ...prev,
            [name]: deuda.periodos
          };
        });
      }
      else {
        let checkboxs = document.getElementsByName([name]);
        checkboxs.forEach(p => p.checked = false);

        setMonto((prev) => {
          return {
            ...prev,
            [name]: 0
          };
        });
        setMontoOrigen((prev) => {
          return {
            ...prev,
            [name]: 0
          };
        });
        setMontoInteres((prev) => {
          return {
            ...prev,
            [name]: 0
          };
        });

        setPeridosList((prev) => prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)));

        setCuotasRafam((prev) => {
          return {
            ...prev,
            [name]: []
          };
        });
      }
    });
  };

  const handleSelect = (e, name) => {
    if (name === "caracter") {
      setCaracter(e);
    }
    else if (name === "estado") {
      setEstado(e);
    }
    else {
      setFormaPago(e);
    }
  };

  const handleRemove = (item) => {
    setDeudas(prev => {
      return prev.filter(e => !(e.recurso === item.recurso && e.imponible === item.imponible));
    });

    setTotal(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });
    setTotalOrigen(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });
    setTotalInteres(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    setCuotas(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    setContado(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    setPeridosList((prev) => prev.filter((p) => !(p.imponible === item.imponible && p.recurso === item.recurso)));

    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: monto[current]
          };
        }
      }, {});
      let resultInteres = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: montoInteres[current]
          };
        }
      }, {});
      let resultOrigen = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: montoOrigen[current]
          };
        }
      }, {});

      setMonto(result);
      setMontoOrigen(resultOrigen);
      setMontoInteres(resultInteres);
    }

    if (Object.values(cuotasRafam).length) {
      let result = Object.keys(cuotasRafam)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: cuotasRafam[current]
          };
        }
      }, {});

      setCuotasRafam(result);
    }
  };
  //  `CALL ingconvenio( :abogado, :estado, :formapago, :cuotaspago, :montopago, :otgastos, :estporc, :estgstfijo, :obsotgastos, :obs, :dni, :fecha, :nombre, :direccion, :localidad, :telefono, :cel, :email, :caracter, :caracterotros, :planes, :cuotas )`,
  const onSubmit = async (newData) => {
    try {
      dispatch(setLoading(true));
      let planes = [];

      if (Object.keys(total)?.length) {
        for (const element in total) {
          if (total[element]) {
            const [recurso, imponible] = element.split("-");
            const contribuyente = deudas.find(e => e.recurso === e.recurso && imponible === e.imponible)?.contribuyente;

            if (contado[recurso + "-" + imponible]) {
              planes.push({
                r: recurso,
                i: imponible,
                i50: 0,
                c: "1",
                m: `${total[element]}`,
                origen: `${totalOrigen[element]}`,
                intereses: `${totalInteres[element]}`,
                cnt: contribuyente?.APYNOM
              });
            }
            else {
              const tipoCuotas = {
                W2113: 6,
                W2112: 3,
                W2200: 3,
                W2201: 1,
                W2203: 6,
                ABLT: cuotas[recurso + "-" + imponible] || defaultCuotas,
                "SHANT_6": 6,
                "SHANT_12": 12,
                SHCON: 1,
              };

              planes.push({
                r: recurso,
                i: imponible,
                i50: 0,
                c: tipoPlan[recurso + "-" + imponible] ? tipoCuotas[tipoPlan[recurso + "-" + imponible]] : (cuotas[recurso + "-" + imponible] || defaultCuotas),
                m: `${total[element]}`,
                tipoPlan: tipoPlan[recurso + "-" + imponible],
                origen: `${totalOrigen[element]}`,
                intereses: `${totalInteres[element]}`,
                cnt: contribuyente?.APYNOM
              });
            }
          }
        }
      }

      let cuotasArray = [];
      if (periodosList?.length) {
        cuotasArray = periodosList.map((e) => {
          return {
            r: e.recurso,
            i: e.imponible,
            a: e.ANIO,
            c: e.CUOTA,
          };
        });
      }

      dispatch(setLoading(false));
      if (!planes.length) {
        dispatch(setLoading(false));
        return Swal.fire("Incompleto", "Debe seleccionar una deuda.", "warning");
      }

      newData.planes = JSON.stringify(planes.flat());
      newData.cuotas = pako.gzip(JSON.stringify(cuotasArray));

      newData.abogado = user?.abogado;
      newData.montopago = newData.montopago ? newData.montopago : "0";
      newData.cuotaspago = newData.cuotaspago ? newData.cuotaspago : "0";
      newData.otgastos = gastosFijos;
      newData.estporc = estado.porcentual ? estado.porcentual : "0";
      newData.titulo = caracter;

      dispatch(setLoading(false));
      const response = await convenioService.createConvenio(newData);

      if (response?.ok) {
        dispatch(getConvenios(filters));
        dispatch(setLoading(false));
        Swal.fire({
          title: "Exito",
          icon: "success",
          willClose: () => handleNewConvenio(),
        });
      }
      else {
        dispatch(setLoading(false));
        Swal.fire("Error", (typeof response === "string" && response) || "Ocurrio un error intentelo nuevamente", "error");
      }
    }
    catch (err) {
      dispatch(setLoading(false));
      console.log(err);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column jusitfy-content-center align-items-center" style={{ overflowX: "auto" }}>
        <div className="convenio-title mb-4">
          <h4>Nuevo Convenio</h4>
        </div>
        <div className="buscar-deudas">
          <Tabs
            activeKey={key}
            onSelect={(k) => {
              setComercios(k === "comercios");
              setKey(k);
            }}
          >
            <Tab eventKey="inmuebles" title="INMUEBLES">
              {key === "inmuebles" && (
                <BuscarDeudas setDeudas={setDeudas} deudas={deudas} handleRemove={handleRemove} />
              )}
            </Tab>
            <Tab eventKey="comercios" title="COMERCIOS">
              {key === "comercios" && (
                <BuscarDeudas setDeudas={setDeudas} deudas={deudas} handleRemove={handleRemove} comercios={comercios} />
              )}
            </Tab>
          </Tabs>
        </div>

        {deudas?.length ? deudas.map(({ imponible, recurso, legal }, i) => {
          const findAbogado = abogados.find((e) => legal?.length && e.codexterno === legal[legal.length - 1].LEGAL);

          return (
            <div key={imponible + recurso + i} style={{ width: "100%", padding: "2rem", overflow: "auto" }}>
              {legal?.length ? (
                <Table
                  className="subtable legal-subtable"
                  striped
                  bordered
                  hover
                >
                  <tbody>
                    <tr>
                      <td colSpan={3} className="subtable-subtitulo">Abogado {`${findAbogado?.apellido} ${findAbogado?.nombre}`.toUpperCase()} ({legal[legal.length - 1].LEGAL}). Recurso: {recurso || ""} - Imponible: {imponible || ""}</td>
                    </tr>
                    <tr>
                      <td colSpan={3} className="subtable-subtitulo">Períodos Legal</td>
                    </tr>
                    <tr>
                      <td className="subtable-key">
                        <div className="d-flex align-items-center ">
                          <Form.Check
                            name={`${imponible}-${recurso}`}
                            id={`${imponible}-${recurso}`}
                            className="input-check"
                            onChange={(e) => handleCheck({ e, deudas: formatDeuda(legal), imponible, recurso })}
                          />
                          <Form.Label className="mt-1" htmlFor={`${imponible}-${recurso}`}>Seleccionar todo</Form.Label>
                        </div>
                      </td>
                      <td className="subtable-key"></td>
                      <td className="subtable-key"></td>
                    </tr>
                    <tr>
                      <td className="subtable-key">Año</td>
                      <td className="subtable-key">Período</td>
                      <td className="subtable-key">Monto</td>
                    </tr>
                    {formatDeuda(legal)?.length ?
                      formatDeuda(legal).map((deuda, indx) => {
                        let name = `${imponible}-${recurso}-${deuda.anio}-${indx}`;

                        return (
                          <tr key={"plan" + indx + recurso}>
                            <td className="subtable-key">
                              <div className="d-flex align-items-center ">
                                <Form.Check
                                  name={name}
                                  value={deuda.anio}
                                  onChange={(e) => handleYear({ e, periodosData: deuda.periodos, valueMonto: deuda.monto.toFixed(2), deuda, imponible, recurso, valueOrigen: deuda.origen.toFixed(2), valueInteres: deuda.interes.toFixed(2), })}
                                />
                                <Form.Label className="" >{deuda.anio}</Form.Label>
                              </div>
                            </td>
                            <td className="d-flex" style={{ height: 54 }}>
                              {
                                deuda?.periodos?.length ? deuda.periodos.map((periodo, i) => {
                                  return (
                                    <div className="d-flex align-items-center ml-3" key={deuda.anio + periodo?.CUOTA + i}>
                                      <Form.Check
                                        value={periodo?.CUOTA}
                                        name={name}
                                        className=""
                                        onChange={(e) => handlePeriodos({ e, valueMonto: +Number(periodo?.TOTAL).toFixed(2), periodo, imponible, recurso, valueOrigen: +Number(periodo?.ORIGEN).toFixed(2), valueInteres: +Number(periodo?.INTERES).toFixed(2)})}
                                      />
                                      <Form.Label className="" >{periodo?.CUOTA}</Form.Label>
                                    </div>
                                  );
                                })
                                  : null
                              }
                            </td>
                            <td className="subtable-key">$ {monto[name] ? monto[name] : 0}</td>
                          </tr>
                        );
                      }) : null}
                    <tr>
                      <td colSpan={2} className="subtable-key" style={{ textAlign: "right" }}>Total</td>
                      <td className="subtable-key">$ {total[recurso + "-" + imponible] ? +Number(total[recurso + "-" + imponible]).toFixed(2) : 0}</td>
                    </tr>
                    <tr>
                      <td colSpan={3} className="subtable-key" style={{ textAlign: "right" }}>
                        <SelectPlan
                          recurso={recurso}
                          imponible={imponible}
                          handleShowModal={handleShowModal}
                          handleCuotas={handleCuotas}
                          setCuotas={setCuotas}
                          setTipoPlan={setTipoPlan}
                          tipoPlan={tipoPlan}
                          setAnticipo={setAnticipo}
                          anticipo={anticipo}
                          contado={contado}
                          total={total[recurso + "-" + imponible] ? +Number(total[recurso + "-" + imponible]).toFixed(2) : 0}
                          type={key}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3} className="subtable-key" style={{ textAlign: "right" }}>
                        <div className="d-flex justify-content-end align-items-center">
                          <Form.Check
                            id={recurso + "-" + imponible}
                            name={recurso + "-" + imponible}
                            className="input-check mr-2"
                            onChange={handleContado}
                          />
                          <Form.Label
                            htmlFor={recurso + "-" + imponible}
                            style={{
                              cursor: "pointer"
                            }}
                          >
                            EN CONTADO
                          </Form.Label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              ) : null}

            </div>
          );
        }) : null}
      </div>

      {showSimulacion ? <SimulacionPlanPago show={showSimulacion} handleClose={handleCloseModal} data={simulacionpp} /> : null}


      <Form className="edit-convenio" onSubmit={handleSubmit(onSubmit)}>
        <Form.Group>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Fecha de Firma</Form.Label>
              <Form.Control
                type="date"
                name="fecha"
                className={`${errors.fecha ? "is-invalid" : ""}`}
                {...register("fecha", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.fecha?.message}</Form.Control.Feedback>
            </Col>
            <Col>
              <Form.Label className="mb-2">Se presenta en carácter de</Form.Label>
              <Controller
                name="caracter"
                control={control}
                rules={{ required: "El campo es obligatorio" }}
                render={({ field: { onChange } }) => {
                  return (
                    <ReactSelect
                      options={convCaracter?.length ? [emptyOption, ...convCaracter] : [emptyOption]}
                      value={caracter || ""}
                      onChange={(e) => {
                        handleSelect(e, "caracter");
                        return onChange(e?.value);
                      }}
                      styles={errors.caracter ? selectErrorStyles : selectStyles}
                    />
                  );
                }}
              />
              {errors.caracter ? (
                <div
                  className="invalid"
                  style={{
                    fontSize: "80%",
                    color: "#dc3545",
                    marginTop: 3
                  }}
                >
                  {errors.caracter.message}
                </div>
              ) : ""}
            </Col>
            <Col>
              <Form.Label className="mb-2">Otros</Form.Label>
              <Form.Control
                name="caracterotros"
                {...register("caracterotros")}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">DNI</Form.Label>
              <Form.Control
                name="dni"
                type="number"
                className={`${errors.dni ? "is-invalid" : ""}`}
                {...register("dni", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.dni?.message}</Form.Control.Feedback>
            </Col>
            <Col>
              <Form.Label className="mb-2">Apellido y Nombre</Form.Label>
              <Form.Control
                name="nombre"
                className={`${errors.nombre ? "is-invalid" : ""}`}
                {...register("nombre", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.nombre?.message}</Form.Control.Feedback>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Teléfono</Form.Label>
              <Form.Control
                name="telefono"
                type="number"
                className={`${errors.telefono ? "is-invalid" : ""}`}
                {...register("telefono", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.telefono?.message}</Form.Control.Feedback>
            </Col>
            <Col>
              <Form.Label className="mb-2">Celular</Form.Label>
              <Form.Control
                name="cel"
                type="number"
                className={`${errors.cel ? "is-invalid" : ""}`}
                {...register("cel", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.cel?.message}</Form.Control.Feedback>
            </Col>
            <Col>
              <Form.Label className="mb-2">E-Mail</Form.Label>
              <Form.Control
                name="email"
                className={`${errors.email ? "is-invalid" : ""}`}
                {...register("email", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Localidad</Form.Label>
              <Form.Control
                name="localidad"
                className={`${errors.localidad ? "is-invalid" : ""}`}
                {...register("localidad", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.localidad?.message}</Form.Control.Feedback>

            </Col>
            <Col>
              <Form.Label className="mb-2">Dirección</Form.Label>
              <Form.Control
                name="direccion"
                className={`${errors.direccion ? "is-invalid" : ""}`}
                {...register("direccion", { required: "El campo es obligatorio" })}
              />
              <Form.Control.Feedback type="invalid">{errors.direccion?.message}</Form.Control.Feedback>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Estado</Form.Label>
              <Controller
                name="estado"
                control={control}
                rules={{ required: "El monto es requerido." }}
                render={({ field: { onChange } }) => {
                  return (
                    <ReactSelect
                      options={convEstadosState?.length ? [emptyOption, ...convEstadosState] : [emptyOption]}
                      onChange={(e) => {
                        handleSelect(e, "estado");
                        return onChange(e?.value);
                      }}
                      value={estado ? estado : ""}
                      styles={errors.estado ? selectErrorStyles : selectStyles}
                    />
                  );
                }}
              />
              {errors.estado ? (
                <div
                  className="invalid"
                  style={{
                    fontSize: "80%",
                    color: "#dc3545",
                    marginTop: 4
                  }}
                >
                  {errors.estado.message}
                </div>
              ) : ""}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Hon.s/Deuda</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="hnDeuda"
                  value={fixNumber(totalDeuda * +estado?.porcentual)}
                  {...register("hnDeuda", { value: fixNumber(totalDeuda * +estado?.porcentual) })}
                  disabled
                />
              </InputGroup>
            </Col>
            <Col>
              <Form.Label className="mb-2">Gasto Fijo</Form.Label>
              {/* <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="estgstfijo"
                  value={totalDeuda ? formatGastoFijo(totalDeuda, estado) : 0}
                  {...register("estgstfijo", { value: totalDeuda ? formatGastoFijo(totalDeuda, estado) : 0 })}
                  disabled
                />
              </InputGroup> */}
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="estgstfijo"
                  value={estado ? estado.jus : 0}
                  {...register("estgstfijo", { value: estado ? estado.jus : 0 })}
                  disabled
                />
              </InputGroup>
            </Col>
          </Row>
          {/* <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Otros Gastos</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="number"
                  name="otgastos"
                  {...register("otgastos")}
                />
              </InputGroup>
            </Col>
            <Col>
              <Form.Label className="mb-2">Obs Otros Gastos</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                name="obsotgastos"
                style={{ height: 50 }}
                {...register("obsotgastos")}
              />
            </Col>
          </Row> */}
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Total Hon.</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  value={fixNumber((totalDeuda * +estado?.porcentual) + (+estado.jus || 0) + (+getValues("otgastos") || 0))}
                  disabled
                />
              </InputGroup>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Forma de Pago</Form.Label>
              <Controller
                name="formapago"
                control={control}
                rules={{ required: "El campo es obligatorio" }}
                render={({ field: { onChange } }) => {
                  return (
                    <ReactSelect
                      options={convFormaPago?.length ? [emptyOption, ...convFormaPago] : [emptyOption]}
                      onChange={(e) => {
                        handleSelect(e, "formapago");
                        return onChange(e?.value);
                      }}
                      value={formaPago ? formaPago : ""}
                      styles={errors.formapago ? selectErrorStyles : selectStyles}
                    />
                  );
                }}
              />
              {errors.formapago ? (
                <div
                  className="invalid"
                  style={{
                    fontSize: "80%",
                    color: "#dc3545",
                    marginTop: 3
                  }}
                >
                  {errors.formapago.message}
                </div>
              ) : ""}
            </Col>
          </Row>
          <Row className="mb-1">
            {formaPago.nombre === "Mixto" ? (
              <Col>
                <Form.Label className="mb-2">Monto</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    name="montopago"
                    {...register("montopago")}
                  />
                </InputGroup>
              </Col>
            ) : null}
            {formaPago.nombre === "En Cuotas" || formaPago.nombre === "Mixto" ? (
              <Col>
                <Form.Label className="mb-2">Cuotas</Form.Label>
                <Form.Control
                  name="cuotaspago"
                  {...register("cuotaspago")}
                />
              </Col>
            ) : null}
          </Row>
          <Row className="mb-1">
            <Col>
              <Form.Label className="mb-2">Observaciones</Form.Label>
              <Form.Control
                as={"textarea"}
                name="obs"
                {...register("obs")}
              />
            </Col>
          </Row>
        </Form.Group>
        <Row className="mb-1">
          <Col className="d-flex justify-content-end">
            <Button type="submit" className="custom-button" style={{ maxWidth: 190 }}>Grabar Convenio</Button>
          </Col>
          <Col>
            <Button variant="danger" className="danger-button" onClick={handleNewConvenio} style={{ maxWidth: 190 }}>Cancelar Convenio</Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    data: state.dashboard.convenio,
    convCaracter: state.dashboard.convCaracter,
    convEstados: state.dashboard.convEstados,
    convFormaPago: state.dashboard.convFormaPago,
    loading: state.dashboard.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConvenio: (id) => dispatch(getConvenio(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewConvenio);